import { useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useMutation, useQueryClient, useQuery } from 'react-query'

import { updateIdentificationsHampstaAddReplaceAPI } from 'api/identifications'
import { useIdentificationsStore } from 'store/identifications'

import {
  IdentificationsDataTypes,
  IdentificationsHampstaAddReplaceParamsTypes,
} from 'types/identifications'

import { DATASTATUS } from 'constants/status'

export const useMemberIdentificationsMerge = ({
  modalClose,
  selectedRowData,
}: {
  modalClose: () => void
  selectedRowData: IdentificationsDataTypes
}) => {
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')
  const { ident } = selectedRowData

  const identificationsMergeModStatus = useIdentificationsStore(
    (state) => state.identificationsMergeModStatus
  )
  const identificationsMergeModStatusSet = useIdentificationsStore(
    (state) => state.identificationsMergeModStatusSet
  )

  const [
    identificationsHampstaAddReplaceParams,
    identificationsHampstaAddReplaceParamsSet,
  ] = useState<IdentificationsHampstaAddReplaceParamsTypes>({
    traderId: memberTraderId,
    flReplace: 0,
    cardColor: '',
    name: '',
    oldCard: ident,
  })

  const queryClient = useQueryClient()
  const { mutateAsync } = useMutation({
    mutationFn: updateIdentificationsHampstaAddReplaceAPI,
    mutationKey: 'updateIdentificationsHampstaAddReplace',
    onMutate: () => {
      identificationsMergeModStatusSet('loading')
    },
    onSuccess: (getOffersIdentsResponse) => {
      queryClient.invalidateQueries({
        queryKey: ['useIdentifications'],
      })
      identificationsMergeModStatusSet('success')
    },
    onError: (error) => {
      identificationsMergeModStatusSet('fail')
    },
  })

  const handleAddReplace = useCallback(
    async (addreplaceParams: IdentificationsHampstaAddReplaceParamsTypes) => {
      try {
        const response = await mutateAsync({
          ...identificationsHampstaAddReplaceParams,
          ...addreplaceParams,
        })
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        toast.success('Member identification merge update successful.')
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        if (message.outcomeCode === 'IDENT:HDA_MERGE_CUSTOMER:-1') {
          // toast.error(`Something went wrong.`)
          toast.error(message.outcomeUserMessage)
        } else {
          // toast.error(`Member identification merge update error.`)
          toast.error(message.outcomeUserMessage)
        }
        // modalClose()
      } finally {
        // console.log('')
        // modalClose()
      }
      modalClose()
    },
    [mutateAsync]
  )

  return {
    memberIdentificationsMergeModStatus: identificationsMergeModStatus,
    memberIdentificationsHampstaAddReplaceParams:
      identificationsHampstaAddReplaceParams,
    memberHandleIdentificationsAddReplace: handleAddReplace,
  }
}
